import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { chargeSlabQueries } from '@/services/chargeSlab/chargeSlab.queries';
import { useSearch } from '@tanstack/react-router';

export const useGetChargeSlab = () => {
  const search = useSearch({ from: '/(app)/configuration-management/charges/$categoryId/slabs/' });
  const { page, fetch, subCategoryId, agentType, sort } = search;
  const { data, isLoading } = useQuery({
    ...chargeSlabQueries.list({
      row: page ?? 1,
      agentType: agentType ?? '',
      categoryId: subCategoryId ?? '',
      fetch: fetch ?? 10,
      search: search.q ?? '',
    }),

    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });
  return { data: data?.data || [], isLoading, meta: data?.meta.pagination };
};
